import { formatarDataBRpISO } from './formatDate';

export function isValidDate(dateString: string) {
  // Regex para validar o formato DD/MM/YYYY
  const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;

  if (!dateRegex.test(dateString)) {
    return false; // Formato inválido
  }

  // Separar o dia, mês e ano
  const [day, month, year] = dateString.split('/').map(Number);

  // Criar um objeto Date (os meses no JavaScript vão de 0 a 11)
  const date = new Date(year, month - 1, day);

  // Verificar se a data criada corresponde ao dia, mês e ano
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
}

/**
 * Verifica se a data fornecida é uma data futura
 * @param dateString Data no formato dd/mm/yyyy
 * @returns Retorna `true` em caso de data futura, `null` em caso de data inválida
 */
export function isFutureDate(dateString: string) {
  if (isValidDate(dateString)) {
    const formattedDate = formatarDataBRpISO(dateString).replace('-', '/');

    const today = Date.now();
    const testDate = new Date(formattedDate).getTime();

    return testDate > today;
  }

  return null;
}
